<div class="container">
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <div class="panel panel-default">
                <div class="panel-heading">Signup</div>
                <div class="panel-body">
                    <form class="form-horizontal" role="form" (submit)="onSignup(signupForm)" #signupForm="ngForm"> 
                        <div class="form-group">
                            <label for="email" class="col-md-4 control-label">Name</label>
                            <div class="col-md-6">
                                <input ngModel type="text" class="form-control" name="name" required>
                            </div>
                        </div>                       
                        <div class="form-group">
                            <label for="email" class="col-md-4 control-label">E-Mail</label>
                            <div class="col-md-6">
                                <input ngModel type="email" class="form-control" name="email" required>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="password" class="col-md-4 control-label">Password</label>
                            <div class="col-md-6">
                                <input ngModel type="password" class="form-control" name="password" required>
                            </div>
                        </div>                        
                        <div class="form-group">
                            <div class="col-md-6 col-md-offset-4">
                                <button [disabled]="signupForm.invalid || isSubmitted" type="submit" class="btn btn-primary">
                                    <i class="fa fa-btn fa-sign-in"></i> Signup
                                </button>                              
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>